import { render, staticRenderFns } from "./form-template-signer-name.vue?vue&type=template&id=2b2743e2&scoped=true&lang=pug"
import script from "./form-template-signer-name.vue?vue&type=script&lang=js"
export * from "./form-template-signer-name.vue?vue&type=script&lang=js"
import style0 from "./form-template-signer-name.vue?vue&type=style&index=0&id=2b2743e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2743e2",
  null
  
)

export default component.exports